const inputValidator = require('./lib/input/ValidateInput')
const validateForm = require('./lib/form/validateForm')

exports.validateInput = inputValidator;
exports.validateForm = validateForm;
exports.formValidate = formValidate;

function formValidate() {
    document.querySelectorAll("[form-validade]").forEach((form) => {
        form.querySelectorAll("input").forEach((input) => {

            if (input.type == "file") {
                return;
            }

            const fileldDetails = [{
                id: input.id,
                errorClassName: "error",
                errorId: input.id + "-message-error",
                errorMessage: input.dataset.errormessage,
                validator: (inputVal) => {
                    var isValid = false

                    if (input.classList.contains("email")) {
                        isValid = inputVal.includes("@")
                    } else if (input.classList.contains("phone")) {
                        isValid = inputVal.length == 11
                    }

                    if (input.dataset.minlength) {
                        isValid = inputVal.length >= input.dataset.minlength
                    }

                    return isValid
                }
            }]

            validateForm(form.id, fileldDetails);
        })

        form.querySelectorAll("textarea").forEach((input) => {
            const fileldDetails = [{
                id: input.id,
                errorClassName: "error",
                errorId: input.id + "-message-error",
                errorMessage: input.dataset.errormessage,
                validator: (inputVal) => {
                    var isValid = false

                    if (input.dataset.minlength.length) {
                        isValid = inputVal.length >= input.dataset.minlength
                    }

                    return isValid
                }
            }]

            validateForm(form.id, fileldDetails);
        })

        form.querySelectorAll("select").forEach((select) => {
            const fileldDetails = [{
                id: select.id,
                errorClassName: "error",
                errorId: select.id + "-message-error",
                errorMessage: select.dataset.errormessage ? select.dataset.errormessage : "Inválido",
                validator: (selectVal) => {
                    var isValid = false

                    if (selectVal) {
                        isValid = true
                    }

                    return isValid
                }
            }]

            validateForm(form.id, fileldDetails);
        })
    })
}

